export default __webpack_public_path__ + "static/media/vueds.69bf0718.webp";